"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.beautify = void 0;
require("codemirror/lib/codemirror.css");
require("codemirror/theme/material.css");
require("codemirror/mode/javascript/javascript");
require("codemirror/addon/lint/lint");
require("codemirror/addon/lint/json-lint");
require("codemirror/addon/lint/lint.css");
require("codemirror/addon/lint/javascript-lint");
require("codemirror/addon/edit/closebrackets");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsonlintMod = _interopRequireDefault(require("jsonlint-mod"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactCodemirror = require("react-codemirror2");
var _jsBeautify = require("js-beautify");
var _automationHooks = require("@airportlabs/automation-hooks");
var _formik = require("formik");
var FieldParts = _interopRequireWildcard(require("../Inputs/FieldParts"));
var _excluded = ["label", "info", "isRequired", "height", "tabIndex", "mB", "automationHook", "onFormikChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** The name of the field */
  name: _propTypes["default"].string.isRequired,
  /** Label displayed above the input */
  label: _propTypes["default"].string,
  /** Description that appears under the field, explaining what it does */
  info: _propTypes["default"].string,
  /** The css height property value for the textarea. */
  height: _propTypes["default"].string,
  /** The tab index to assign to the editor. */
  tabIndex: _propTypes["default"].number,
  /** Wether this field is required or not. */
  isRequired: _propTypes["default"].bool,
  /** Wether or not the element should have a margin bottom */
  mB: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string,
  /** Extra function to call after the formik field is changed. Receives an object with value. */
  onFormikChange: _propTypes["default"].func
};
var CodeMirror = (0, _styledComponents["default"])(_reactCodemirror.Controlled).withConfig({
  displayName: "JsonTextAreaFormik__CodeMirror",
  componentId: "sc-he7dv-0"
})(["", ""], function (props) {
  return props.height && (0, _styledComponents.css)([".CodeMirror{height:", ";}"], props.height);
});
window.jsonlint = _jsonlintMod["default"];
var beautify = exports.beautify = function beautify(value) {
  return (0, _jsBeautify.js)(value, {
    indent_size: 2
  });
};
var JsonTextAreaFormik = function JsonTextAreaFormik(_ref) {
  var label = _ref.label,
    info = _ref.info,
    isRequired = _ref.isRequired,
    height = _ref.height,
    tabIndex = _ref.tabIndex,
    mB = _ref.mB,
    automationHook = _ref.automationHook,
    onFormikChange = _ref.onFormikChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    lintingErrors = _useState2[0],
    setLintingErrors = _useState2[1];
  var _useField = (0, _formik.useField)(_objectSpread(_objectSpread({}, props), {}, {
      validate: function validate(value) {
        if (lintingErrors && value) {
          return "This field must contain valid JSON";
        }
      }
    })),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var partialField = (0, _react.useMemo)(function () {
    return (0, _omit["default"])(field, "onChange");
  }, [field]);
  var onBeforeChange = (0, _react.useCallback)(function (editor, data, value) {
    helpers.setValue(value);
    helpers.setTouched(true, false);
    onFormikChange === null || onFormikChange === void 0 ? void 0 : onFormikChange({
      value: value
    });
  }, [helpers, onFormikChange]);
  var onBlur = (0, _react.useCallback)(function (editor, event) {
    field.onBlur(event);
    helpers.setValue(beautify(editor.getValue(""), {
      indent_size: 2
    }));
  }, [helpers, field]);
  return /*#__PURE__*/_react["default"].createElement(FieldParts.Wrapper, {
    mB: mB
  }, label && /*#__PURE__*/_react["default"].createElement(FieldParts.Label, _extends({
    hasError: meta.touched && meta.error
  }, (0, _automationHooks.hook)(automationHook, "field-label")), label), /*#__PURE__*/_react["default"].createElement(CodeMirror, _extends({
    height: height,
    options: _objectSpread({
      foldGutter: true,
      readOnly: false,
      lineNumbers: true,
      mode: "application/json",
      styleActiveLine: true,
      line: true,
      json: true,
      lineWrapping: false,
      smartIndent: true,
      gutters: ["CodeMirror-lint-markers"],
      lint: partialField.value && {
        onUpdateLinting: function onUpdateLinting(annotations) {
          setLintingErrors(!!annotations.length);
        },
        options: {}
      },
      continueComments: "Enter",
      matchBrackets: true,
      closeBrackets: true,
      indentUnit: 2,
      tabSize: 2,
      theme: "material"
    }, tabIndex && {
      tabindex: tabIndex
    })
  }, partialField, props, {
    onBeforeChange: onBeforeChange,
    onBlur: onBlur
  }, (0, _automationHooks.hook)(automationHook, "input"))), info && /*#__PURE__*/_react["default"].createElement(FieldParts.Info, (0, _automationHooks.hook)(automationHook, "field-info"), info), meta.error && meta.touched && /*#__PURE__*/_react["default"].createElement(FieldParts.Error, (0, _automationHooks.hook)(automationHook, "field-error"), meta.error));
};
JsonTextAreaFormik.propTypes = propTypes;
var _default = exports["default"] = JsonTextAreaFormik;